import { render, staticRenderFns } from "./BaseArticle.vue?vue&type=template&id=654c609a"
import script from "./BaseArticle.vue?vue&type=script&lang=js"
export * from "./BaseArticle.vue?vue&type=script&lang=js"
import style0 from "./BaseArticle.vue?vue&type=style&index=0&id=654c609a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports